import { useContext } from 'react'
import { StoreContext } from '~/store'
import { emitCustomEvent } from 'react-custom-events'
import { getLocalizedSlug } from '~/components/ProfileModule'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames/bind'
import * as styles from './index.module.css'

const cx = classnames.bind(styles)

const getFirstName = user => {
  return user?.firstName || user?.lastName?.trim().replace(/\s.+/, '')
}

const getInitials = user => {
  if (user.firstName !== undefined && user.lastName === undefined) {
    return user?.firstName?.substring(0, 2).toUpperCase()
  }
  else if (user.firstName === undefined && user.lastName !== undefined) {
    return user?.lastName?.substring(0, 2).toUpperCase()
  }
  return user?.firstName?.charAt(0).toUpperCase() + user?.lastName?.charAt(0).toUpperCase()
}

export default function EmbedHeader() {
  const { t } = useTranslation()
  const { user, logoutUser } = useContext(StoreContext)
  const providerId = window.EMBED_CONFIG?.providerId || ''

  const handleLogin = () => {
    emitCustomEvent('SHOW_LOGIN', { show: true })
  }

  const handleLogout = () => {
    if (window.confirm(t('confirm-logout') || 'Vill du logga ut?')) {
      logoutUser()
    }
  }

  const profileUrl = user ? getLocalizedSlug('root') : null

  const logoUrl = window.EMBED_CONFIG?.logoUrl || '/app/themes/taxi-stockholm/static/img/logo.png'

  return (
    <div className={cx(styles.header)}>
      <a href="/" className={cx(styles.logo)} target="_blank" rel="noopener noreferrer">
        <span 
          className={cx(styles.logoImage)} 
          style={{ backgroundImage: `url(${logoUrl})` }}
        ></span>
      </a>
      
      <div className={cx(styles.actions)}>
        {user ? (
          <>
            <a
              href={profileUrl}
              className={cx(styles.userInfo)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={cx(styles.userName)}>{getFirstName(user)}</span>
              <div className={cx(styles.userAvatar)}>{getInitials(user)}</div>
            </a>
            
          </>
        ) : (
          <button
            className={cx(styles.loginButton)}
            onClick={handleLogin}
          >
            {t('button-login') || 'Logga in'}
          </button>
        )}
      </div>
    </div>
  )
}

